import React, { useMemo } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import Tag from '..';

interface Props {
  time: { hours: number; minutes: number };
  className?: string;
  showIcon?: boolean;
}

const ExpirationTag = ({ time, showIcon }: Props) => {
  const { t } = useStoreTranslation();

  const text = useMemo(
    () =>
      time.minutes < 0 || time.hours < 0
        ? t('tags.expirationTag.expiredTag')
        : time.hours < 1
        ? t('tags.expirationTag.expirationMinutes', { count: time.minutes })
        : t('tags.expirationTag.expirationHour', { count: time.hours }),
    [time, t],
  );
  const color = useMemo(() => (time.hours < 3 ? 'red' : 'yellow'), [time]);

  return (
    <Tag color={color} icon={showIcon ? 'clock' : undefined}>
      {text}
    </Tag>
  );
};

export default ExpirationTag;
